const splittingArrayIntoChunks = (size=500,data=[]) => { 
   return data.reduce((acc, curr, i) => {
        if ( !(i % size)  ) {    // if index is 0 or can be divided by the `size`...
          console.log(acc.length)
          acc.push(data.slice(i, i + size))   // ..push a chunk of the original array to the accumulator
        }
        return acc
    }, [])
}

module.exports = splittingArrayIntoChunks